import { Files } from '../../lib/constants/files'
import { CenterEvent } from '../../lib/types/models/center-event/center-event'
import { CenterEventInput } from '../../lib/types/models/center-event/center-event-input'
import { FileInput } from '../../lib/types/models/file/file-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createCenterEvent = async (
  input: CenterEventInput & { centerId: number }
): Promise<CenterEvent> => {
  const { centerId, ...data } = input
  if (data.files?.length) {
    const uploadedFiles = await Promise.all(
      data.files.map((file) => (file ? uploadFile(Files.CENTER_EVENT_ACTION, file) : null))
    )

    data.files = uploadedFiles.filter((file): file is FileInput => file != null)
  }

  return restApiClient
    .url(constructApiUrl(API.centerEvents.create.url, null))
    .post<CenterEvent>({ ...data, centerId })
}
